/* THIS IS FILE IS AUTO-GENERATED BY graphql-codegen. DO NOT EDIT THIS FILE DIRECTLY! */
/* eslint-disable eslint-comments/no-unlimited-disable */
/* eslint-disable */
import * as Types from "../../../types/definitions/vendor/graphql-schema.d";

import { DocumentNode } from "graphql";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type RedeemPromoCodeMutationVariables = Types.Exact<{
  input: Types.RedeemPromoCodeInput;
}>;

export type RedeemPromoCodeMutation = {
  __typename?: "Mutation";
  redeemPromoCode?: {
    __typename?: "RedeemPromoCodePayload";
    result:
      | {
          __typename?: "RedeemPromoCodeError";
          code: Types.RedeemPromoCodeErrorCode;
          message?: string | null;
        }
      | {
          __typename?: "RedeemPromoCodeSuccess";
          promoCode: {
            __typename?: "PromoCode";
            code: string;
            campaignId: string;
            discount:
              | {
                  __typename?: "DiscountFixed";
                  amount?: { __typename?: "Money"; value: number; currency: Types.Currency } | null;
                }
              | { __typename?: "DiscountPercentage"; percentage?: number | null };
          };
        };
  } | null;
};

export const RedeemPromoCodeDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "redeemPromoCode" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "RedeemPromoCodeInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "redeemPromoCode" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "result" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "RedeemPromoCodeSuccess" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "promoCode" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "code" } },
                                  { kind: "Field", name: { kind: "Name", value: "campaignId" } },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "discount" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "InlineFragment",
                                          typeCondition: {
                                            kind: "NamedType",
                                            name: { kind: "Name", value: "DiscountFixed" },
                                          },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: { kind: "Name", value: "amount" },
                                                selectionSet: {
                                                  kind: "SelectionSet",
                                                  selections: [
                                                    {
                                                      kind: "Field",
                                                      name: { kind: "Name", value: "value" },
                                                    },
                                                    {
                                                      kind: "Field",
                                                      name: { kind: "Name", value: "currency" },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                        {
                                          kind: "InlineFragment",
                                          typeCondition: {
                                            kind: "NamedType",
                                            name: { kind: "Name", value: "DiscountPercentage" },
                                          },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: { kind: "Name", value: "percentage" },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "RedeemPromoCodeError" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "code" } },
                            { kind: "Field", name: { kind: "Name", value: "message" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type RedeemPromoCodeMutationFn = Apollo.MutationFunction<
  RedeemPromoCodeMutation,
  RedeemPromoCodeMutationVariables
>;

/**
 * __useRedeemPromoCodeMutation__
 *
 * To run a mutation, you first call `useRedeemPromoCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRedeemPromoCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [redeemPromoCodeMutation, { data, loading, error }] = useRedeemPromoCodeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRedeemPromoCodeMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RedeemPromoCodeMutation,
    RedeemPromoCodeMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RedeemPromoCodeMutation, RedeemPromoCodeMutationVariables>(
    RedeemPromoCodeDocument,
    options,
  );
}
export type RedeemPromoCodeMutationHookResult = ReturnType<typeof useRedeemPromoCodeMutation>;
export type RedeemPromoCodeMutationResult = Apollo.MutationResult<RedeemPromoCodeMutation>;
export type RedeemPromoCodeMutationOptions = Apollo.BaseMutationOptions<
  RedeemPromoCodeMutation,
  RedeemPromoCodeMutationVariables
>;
